document.addEventListener("userDataLoaded", () => {
  if (!fieldMapping) return
  var storedUserData = localStorage.getItem('user_data');
  if (storedUserData) {
      var userData = JSON.parse(storedUserData);
      if (userData) overrideFormValues(userData);
  }

});


function overrideFormValues(userData) {
  if (!fieldMapping) {
    console.log("fieldMapping variable is not set");
    return;
  }

  for (let key in fieldMapping) {
    if (key === "token" || (userData[key] && fieldMapping[key])) {
      var element = document.getElementById(fieldMapping[key].id);
      if (element) {
        if (fieldMapping[key].isSelect) {
          element.selectedIndex = -1;
          for (var i = 0; i < element.options.length; i++) {
            if (element.options[i].value === userData[key]) {
              element.selectedIndex = i;
              break;
            }
          }
        } else {
          if (key === "token") {
            element.value = localStorage.getItem("token");
          } else {
            element.value = userData[key];
          }
        }
      }
    }
  }
}
